const application_name = 'Agri-Tech Solution';
const application_title = 'Agri-Tech Solution Madagascar';
export default application_name;
